import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FAQ = () => {
  const navigate = useNavigate();
  const [openFAQ, setOpenFAQ] = useState(null);

  const faqData = [
    {
      id: 1,
      question: "What is Book For Paws?",
      answer: "Book For Paws is a curated discovery and booking platform that helps pet parents find verified pet-friendly stays, curated events, and much more — all made for real pet lives. Every listing is tail-tested, human-approved, and often sniffed by our founders: Joey & Chandler."
    },
    {
      id: 2,
      question: "What kind of events do you feature?",
      answer: "We bring you pawsome events like: - Pet-friendly treks - Camping under the stars - Pool & beach days - Sailing & swimming sessions - Training workshops & social paw-ties. Most events are run under the guidance of certified trainers, so you can relax while your floof has a blast."
    },
    {
      id: 3,
      question: "Are the listings and events verified?",
      answer: "Yes! Every experience on our site is Book For Paws–tagged and personally verified by our team (and often paw-approved by Joey & Chandler). If it's listed, it's safe, welcoming, and pet-happy."
    },
    {
      id: 4,
      question: "Where and how do I book?",
      answer: "All bookings are done directly through our website. Every stay or event page has live availability, details, and an easy booking process. No back-and-forth DMs, no uncertainty — just smooth paw-planning."
    },
    {
      id: 5,
      question: "How early should I book? Are slots limited?",
      answer: "Yes, most events and getaways have limited slots — especially those with trainers or in high-demand areas. We recommend booking early on the website to secure your spot."
    },
    {
      id: 6,
      question: "Are charges for pets mentioned clearly?",
      answer: "Always. We believe in full transparency. Each listing includes: - Pet policies - Additional charges (if any) - Inclusions and what to expect. No fine print. No surprises."
    },
    {
      id: 7,
      question: "Is this only for dogs?",
      answer: "Nope! While Joey & Chandler are proud doggos, our platform includes stays and experiences for other pets too — like cats, rabbits, or birds — whenever mentioned by our verified hosts."
    },
    {
      id: 8,
      question: "Are trainers at events qualified?",
      answer: "Yes! Our partnered trainers are certified and experienced in handling group activities. We share trainer details in each event listing so you know your pet is in safe paws."
    },
    {
      id: 9,
      question: "Do I need to bring anything for outdoor events?",
      answer: "Each listing has a handy 'What to Pack' section. From water bowls to booties, we help you prep for the pawfect outing."
    },
    {
      id: 10,
      question: "Can I cancel or reschedule after booking?",
      answer: "Cancellation and rescheduling terms vary by event or property. These are clearly mentioned on each listing, so you're never in doubt before booking."
    },
    {
      id: 11,
      question: "Which cities are you live in?",
      answer: "We're currently live in Mumbai & Pune and soon wagging into Bangalore, Hyderabad, Goa, and Gurgaon. New locations are added regularly — so keep checking in!"
    },
    {
      id: 12,
      question: "Do you also offer services like grooming, boarding, or insurance?",
      answer: "Not just yet — but it's coming soon! We're working on a full pet lifestyle ecosystem including: - Verified grooming partners - Safe, trusted boardings - Pet insurance - Custom travel plans"
    },
    {
      id: 13,
      question: "How can I list my property or event on Book For Paws?",
      answer: "We'd love that! If you run a pet-friendly space or host pet events, reach out via our Vendor Onboarding Form on the site. Our team will get in touch to verify and onboard you if it's a pawfect fit."
    },
    {
      id: 14,
      question: "How is Book For Paws different?",
      answer: "We don't just list — we live it. Every place or experience goes through the Joey & Chandler filter — would we go there? Would we wag our tails? If yes, it's in. If not, it's out. Simple."
    },
    {
      id: 15,
      question: "Where can I follow your journey and get updates?",
      answer: "@bookforpaws – For adventure reels, upcoming events, new listings, and behind-the-scenes of Joey & Chandler on duty. @doghealedsoul – A personal page sharing emotional blogs, pet parent stories, Real Talk with pet parents, and all the goofy, honest moments with Joey & Chandler."
    }
  ];

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="bg-[#FAF7F2] md:px-[120px] p-[20px] md:pt-[60px] md:pb-[20px] gap-[16px] flex items-center">
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="hover:bg-gray-100 rounded-full shrink-0"
          aria-label="Go back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_faq_back)">
              <path d="M5 12H19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_faq_back">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <h1 className="text-[20px] font-medium text-black tracking-[-1px]">Frequently Asked Questions</h1>
      </div>

      <div className="md:px-[120px] p-[20px] md:py-[20px] flex flex-col gap-[8px] pb-10 w-full">
        {/* FAQ List */}
        <div className="space-y-4">
          {faqData.map((faq) => (
            <div key={faq.id} className="bg-white rounded-[16px] shadow-sm overflow-hidden">
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full p-[24px] text-left flex items-center justify-between hover:bg-gray-50 transition-colors focus:outline-none focus:bg-gray-50"
              >
                <h3 className="text-[16px] font-medium text-black pr-4 leading-[1.3]">
                  {faq.question}
                </h3>
                <div className={`transform transition-transform duration-200 text-[#FF5E4C] ${
                  openFAQ === faq.id ? 'rotate-180' : ''
                }`}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </div>
              </button>
              
              {openFAQ === faq.id && (
                <div className="px-[24px] pb-[24px]">
                  <div className="border-t border-gray-100 pt-4">
                    <p className="text-[14px] text-[#8c8c8c] leading-[1.4]">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ; 